export interface ScenarioControls {
  targetRecycledSharePct: number;
  materialReductionPct: number;
  transportReductionPct: number;
}

export interface SavedScenario {
  id: string;
  name: string;
  color: string;
  controls: ScenarioControls;
}

export interface ScenarioImpact {
  baseline_total: number;
  scenario_total: number;
  delta: number;
  delta_pct: number;
}

export interface ScenarioSimulationResponse {
  baseline_total: number;
  stage_totals: Record<string, number>;
  current_recycled_share_pct: number;
  recycled_content: ScenarioImpact;
  lightweighting: ScenarioImpact;
  transport_optimization: ScenarioImpact;
}

export const DEFAULT_SCENARIO_CONTROLS: ScenarioControls = {
  targetRecycledSharePct: 50,
  materialReductionPct: 10,
  transportReductionPct: 20,
};

export const MAX_SAVED_SCENARIOS = 4;

export const SCENARIO_COMPARE_COLORS = [
  '#CC8720',
  '#4F7A28',
  '#005B8F',
  '#7A3E9D',
];
